/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 16:49:22
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/avatar.js
 */
export default {
    // avatar 组件
    avatar: {
        src: '',
        shape: 'circle',
        size: 40,
        mode: 'scaleToFill',
        text: '',
        bgColor: '#c0c4cc',
        color: '#ffffff',
        fontSize: 18,
        icon: '',
        mpAvatar: false,
        randomBgColor: false,
        defaultUrl: '',
        colorIndex: '',
        name: ''
    }
}
